import { render, staticRenderFns } from "./ConcentrateSetting.vue?vue&type=template&id=5f8c44c8&scoped=true&"
import script from "./ConcentrateSetting.vue?vue&type=script&lang=js&"
export * from "./ConcentrateSetting.vue?vue&type=script&lang=js&"
import style0 from "./ConcentrateSetting.vue?vue&type=style&index=0&id=5f8c44c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c44c8",
  null
  
)

export default component.exports